import { SERVER_URL, PROTOCOL } from "../config";

const getCertificates = async (token) => {
    const response = await fetch(
        `${PROTOCOL}${SERVER_URL}/certificatesToBeExpired`,
        {
            method: "get",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
            },
        }
    );
    let data;
    if (response.status !== 200) {
        return [];
    } else {
        // Call the .json() method on your response to get your JSON data
        data = await response.json();
    }

    return data;
};

const downloadCertificate = async (firestoreId) => {
    const token = window.localStorage.getItem("token");
    const response = await fetch(
        `${PROTOCOL}${SERVER_URL}/certificate/${firestoreId}/download`,
        {
            method: "get",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
            },
        }
    );
    let data;
    if (response.status !== 200) {
        return null;
    } else {
        // Call the .json() method on your response to get your JSON data
        data = await response.json();
    }

    return data;
};

const requestForUpdateUserDetails = async (data, token) => {
    const response = await fetch(`${PROTOCOL}${SERVER_URL}/updateUserDetails`, {
        method: "put",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
            phone: data.get("phone"),
            firstName: data.get("firstName"),
            lastName: data.get("lastName"),
            jobTitle: data.get("jobTitle"),
            password: data.get("password"),
        }),
    });
    return response;
};

const getUsers = async (token) => {
    const response = await fetch(`${PROTOCOL}${SERVER_URL}/users`, {
        method: "get",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
        },
    });
    let data;
    if (response.status !== 200) {
        return [];
    } else {
        // Call the .json() method on your response to get your JSON data
        data = await response.json();
    }

    return data;
};

const getGoDaddyCreds = async (token) => {
    const response = await fetch(`${PROTOCOL}${SERVER_URL}/godaddycreds`, {
        method: "get",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
        },
    });
    let data;
    if (response.status !== 200) {
        return [];
    } else {
        // Call the .json() method on your response to get your JSON data
        data = await response.json();
    }

    return data;
};

const resetUserPassword = async (uid) => {
    const token = window.localStorage.getItem("token");
    const response = await fetch(
        `${PROTOCOL}${SERVER_URL}/user/${uid}/resetPassword`,
        {
            method: "put",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
            },
        }
    );
    let data;
    if (response.status !== 200) {
        return null;
    } else {
        // Call the .json() method on your response to get your JSON data
        data = await response.json();
    }

    return data;
};

const disableUserAccount = async (uid, disabled) => {
    const token = window.localStorage.getItem("token");
    const response = await fetch(
        `${PROTOCOL}${SERVER_URL}/user/${uid}/disableAccount`,
        {
            method: "put",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
            },
            body: JSON.stringify({
                disabled: disabled,
            }),
        }
    );
    let data;
    if (response.status !== 200) {
        return null;
    } else {
        // Call the .json() method on your response to get your JSON data
        data = await response.json();
    }

    return data;
};

const createUserAccount = async (token, email, password) => {
    const response = await fetch(`${PROTOCOL}${SERVER_URL}/user`, {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
            email,
            password,
        }),
    });
    let data;
    if (response.status !== 200) {
        return null;
    } else {
        // Call the .json() method on your response to get your JSON data
        data = await response.json();
    }

    return data;
};

const addGoDaddyAccount = async (token, apiKey, apiSecret, customerId) => {
    const response = await fetch(`${PROTOCOL}${SERVER_URL}/godaddycred`, {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
            apiKey,
            apiSecret,
            customerId,
        }),
    });
    let data;
    if (response.status !== 200) {
        return null;
    } else {
        // Call the .json() method on your response to get your JSON data
        data = await response.json();
    }

    return data;
};

const verifyGoDaddyCred = async (token, apiKey, apiSecret, customerId) => {
    const response = await fetch(
        `${PROTOCOL}${SERVER_URL}/godaddycred/verify?apiKey=${apiKey}&apiSecret=${apiSecret}&customerId=${customerId}`,
        {
            method: "get",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
            },
        }
    );
    let data;
    if (response.status !== 200) {
        return null;
    } else {
        // Call the .json() method on your response to get your JSON data
        data = await response.json();
    }

    return data;
};

const deleteGoDaddyCred = async (token, credId) => {
    const response = await fetch(
        `${PROTOCOL}${SERVER_URL}/godaddycred/${credId}`,
        {
            method: "delete",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
            },
        }
    );
    let data;
    if (response.status !== 200) {
        return null;
    } else {
        // Call the .json() method on your response to get your JSON data
        data = await response.json();
    }

    return data;
};

const updateUserRole = async (uid, role) => {
    const token = window.localStorage.getItem("token");
    const response = await fetch(
        `${PROTOCOL}${SERVER_URL}/user/${uid}/updateRole`,
        {
            method: "put",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
            },
            body: JSON.stringify({
                role: role,
            }),
        }
    );
    let data;
    if (response.status !== 200) {
        return null;
    } else {
        // Call the .json() method on your response to get your JSON data
        data = await response.json();
    }

    return data;
};

const updateShouldReceiveEmails = async (uid, shouldReceive) => {
    const token = window.localStorage.getItem("token");
    const response = await fetch(
        `${PROTOCOL}${SERVER_URL}/user/${uid}/updateShouldReceiveEmails`,
        {
            method: "put",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
            },
            body: JSON.stringify({
                shouldReceive: shouldReceive,
            }),
        }
    );
    let data;
    if (response.status !== 200) {
        return null;
    } else {
        // Call the .json() method on your response to get your JSON data
        data = await response.json();
    }

    return data;
};

const uploadPrivateKey = async (uid, key) => {
    const token = window.localStorage.getItem("token");
    const response = await fetch(`${PROTOCOL}${SERVER_URL}/key/${uid}`, {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
            key: key,
        }),
    });
    let data;
    if (response.status !== 200) {
        return null;
    } else {
        // Call the .json() method on your response to get your JSON data
        data = await response.json();
    }

    return data;
};

const getPrivateKey = async (uid) => {
    const token = window.localStorage.getItem("token");
    const response = await fetch(`${PROTOCOL}${SERVER_URL}/key/${uid}`, {
        method: "get",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
        },
    });
    let data;
    if (response.status !== 200) {
        return null;
    } else {
        // Call the .json() method on your response to get your JSON data
        data = await response.json();
    }

    return data;
};

const updatePrivateKey = async (uid, key) => {
    const token = window.localStorage.getItem("token");
    const response = await fetch(`${PROTOCOL}${SERVER_URL}/key/${uid}`, {
        method: "put",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
            key: key,
        }),
    });
    let data;
    if (response.status !== 200) {
        return null;
    } else {
        // Call the .json() method on your response to get your JSON data
        data = await response.json();
    }

    return data;
};

const deletePrivateKey = async (uid) => {
    const token = window.localStorage.getItem("token");
    const response = await fetch(`${PROTOCOL}${SERVER_URL}/key/${uid}`, {
        method: "delete",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
        },
    });
    let data;
    if (response.status !== 200) {
        return null;
    } else {
        // Call the .json() method on your response to get your JSON data
        data = await response.json();
    }

    return data;
};

export {
    getCertificates,
    downloadCertificate,
    requestForUpdateUserDetails,
    getUsers,
    resetUserPassword,
    disableUserAccount,
    createUserAccount,
    getGoDaddyCreds,
    addGoDaddyAccount,
    verifyGoDaddyCred,
    deleteGoDaddyCred,
    updateUserRole,
    updateShouldReceiveEmails,
    uploadPrivateKey,
    getPrivateKey,
    deletePrivateKey,
    updatePrivateKey,
};
